module.exports = {
  NODE_ENV: '"production"',
  // SERVER_URL: '"https://dev.prk-pro.com"'
  SERVER_URL: '"https://prk-pro.com/api"'
};



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 95
// module chunks = 1